module.exports = __webpack_public_path__ + "static/media/carousel9.c976a8d1.jpeg";